<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    <div
      class="ui vertical basic segment"
      styel="margin-top:-12px"
      fxLayout="column"
      fxLayoutGap="25px"
      [class.loading]="pending"
    >
      <div fxLayout="column">
        <div fxFlex><strong>USERNAME</strong></div>
        <div fxFlex>
          {{ user?.user?.username }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header"><strong>IP ADDRESS</strong></div>
        <div fxFlex>{{ user?.metadata?.lastIp }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header"><strong>LOCATION</strong></div>
        <div fxFlex>{{ user?.metadata?.lastCountry }}</div>
      </div>
      <div
        *ngIf="modal.context.title !== 'View User Activity'"
        fxLayout="column"
      >
        <div fxFlex><strong>BLACKLISTED BY </strong></div>
        <div fxFlex>
          {{ parseItem(user?.metadata?.blacklistedBy)?.username }}
        </div>
      </div>
      <div
        *ngIf="modal.context.title !== 'View User Activity'"
        fxLayout="column"
      >
        <div fxFlex><strong>BLACKLISTED REASON </strong></div>
        <div fxFlex>
          {{ user?.metadata?.blacklistedReason }}
        </div>
      </div>
      <div
        *ngIf="modal.context.title !== 'View User Activity'"
        fxLayout="column"
      >
        <div fxFlex><strong>BLACKLISTED TIMES </strong></div>
        <div fxFlex>
          {{ user?.metadata?.blacklistedTimes }}
        </div>
      </div>
      <div
        *ngIf="modal.context.title !== 'View User Activity'"
        fxLayout="column"
      >
        <div fxFlex><strong> DATE BLACKLISTED </strong></div>
        <div fxFlex>
          {{ user?.metadata?.dateBlacklisted | date: "medium" }}
        </div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex><strong>LAST ACTIVITY TIME</strong></div>
        <div fxFlex>
          {{ user?.metadata?.lastActivityTime | date: "medium" }}
        </div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex><strong>SUCESSFUL LOGINS</strong></div>
        <div fxFlex>{{ user?.metadata?.successfulLoginAttempts }}</div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex><strong>FAILED LOGIN ATTEMPTS</strong></div>
        <div fxFlex>{{ user?.metadata?.failedLoginAttempts }}</div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex><strong>ACCOUNT LOCKOUT</strong></div>
        <div fxFlex>{{ user?.metadata?.blacklistedTimes }}</div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div *ngIf="modal.context.title == 'See  User Activity'" fxFlex>
          <strong>PASSWORD CHANGES</strong>
        </div>
        <div fxFlex>{{ user?.metadata?.passwordChanges }}</div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex><strong>FILES ACCESS</strong></div>
        <div fxFlex>{{ user?.metadata?.filesAccess }}</div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex><strong>GEOFENCE PROFILES</strong></div>
        <div fxFlex>
          {{ geofenceProfiles?.length ? geofenceProfiles.length : 0 }}
        </div>
      </div>
      <div *ngIf="modal.context.title == 'See User Activity'" fxLayout="column">
        <div fxFlex style="margin-bottom: 5px">
          <strong>RATE LIMIT PROFILES</strong>
        </div>
        <div fxFlex>
          {{ rateLimitProfiles?.length ? rateLimitProfiles.length : 0 }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
</div>
